import { useEffect, useState } from "react";
// import Table from "../../components/common/table/Table";
// import Title from "../../components/common/title/Title";
import { deleteApi, getApi } from "../../services/api/globalApi";
// import { backupListColumns } from "../../constant/tablesColumns/tablesColums";
import axios from "axios";
import { successMessage } from "../../utils/toastify-message/ToastifyMessage";
import { motion } from "framer-motion";

export default function BackupList() {
  const [backupData, setBackupData] = useState([]);

  const getBackup = async (params) => {
    const path = "admin/backups";
    try {
      const response = await getApi({ path, params: { ...params } });
      setBackupData(response?.data?.data?.files);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBackup({});
  }, []);

async function downloadFile(filename) {
  const validName = filename.split(".")[0];

  const response = await getApi({
    path: `admin/backups/${validName}`,
    responseType: "arraybuffer",
    transformResponse: res => res
  });

  const data = response.data;

  // چک امضای zip
  const sig = new Uint8Array(data).subarray(0, 4);
  console.log("signature:", [...sig]);
  console.log(new Uint8Array(response.data).slice(0,4))


  const blob = new Blob([data], { type: "application/zip" });

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}




  async function removeFile(filename) {
    try {
      await deleteApi({
        path: `admin/backups/${filename}`,
      });
      getBackup({});
      successMessage("فایل با موفقیت حذف شد");
    } catch (error) {
      console.log(error);
    }
  }


  console.log('object', backupData);
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
    >
      {/* <Title title={"لیست بک اپ"} /> */}
      <p className="text-gray-900 dark:text-white">لیست بک آپ</p>
      <ul className="divide-y divide-gray-200 dark:divide-gray-700 mt-8">
        {backupData?.length ? backupData?.map((item, index) => {
          return (
            <li key={index} className="py-3">
              <div className="flex items-center space-x-4 rtl:space-x-reverse">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
                    {item.name}
                  </p>
                </div>
                <button
                  onClick={() => downloadFile(item?.name)}
                  type="button"
                  className="focus:outline-none text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-sm px-4 py-1.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900"
                >
                  دانلود
                </button>
                <button
                  onClick={() => removeFile(item?.name)}
                  type="button"
                  className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-md text-sm px-4 py-1.5 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                >
                  حذف
                </button>
              </div>
            </li>
          );
        }) :
          <p className="text-gray-900 dark:text-white w-full text-center p-3">
            هیچ بک آپی وجود ندارد
          </p>
        }
      </ul>
    </motion.div>
  );
}
